import { AppService } from "app/services/app.service";

import { Observable } from "rxjs";

export abstract class AbAmbiente extends AppService {

  abstract getAllAmbientes(): Observable<any>;
  abstract getAllAmbientesPermitePrevisaoVisita(excluirNaoAgendaveis): Observable<any>;

}